import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

export interface TemplateWorkOrderTaskLineItem {
  id: string;
  sort_order: number;
  line_item: string;
  line_item_id: string;
  template_work_order_task_id?: string;
}

interface TemplateWorkOrderTaskLineItemState {
  templateWorkOrderTaskLineItems: TemplateWorkOrderTaskLineItem[];
  templateWorkOrderTaskLineItem: TemplateWorkOrderTaskLineItem | {};
}

const itemDetails = {
  pluralName: "template_work_order_task_line_items",
  singularName: "template_work_order_task_line_item",
};

const emptyTemplateWorkOrderTaskLineItem: TemplateWorkOrderTaskLineItem = {
  id: "",
  template_work_order_task_id: "",
  line_item: "",
  line_item_id: "",
  sort_order: 200,
};

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    template_work_order_task_line_item: {
      ...jsConn.formParams,
    },
  };
};

const state: TemplateWorkOrderTaskLineItemState = {
  templateWorkOrderTaskLineItems: [],
  templateWorkOrderTaskLineItem: {},
};

const mutations = {
  LOAD_TEMPLATE_WORK_ORDER_TASK_LINE_ITEMS(
    state: TemplateWorkOrderTaskLineItemState,
    payload: TemplateWorkOrderTaskLineItem[],
  ) {
    state.templateWorkOrderTaskLineItems = payload;
  },
  LOAD_TEMPLATE_WORK_ORDER_TASK_LINE_ITEM(
    state: TemplateWorkOrderTaskLineItemState,
    payload: TemplateWorkOrderTaskLineItem,
  ) {
    state.templateWorkOrderTaskLineItem = payload;
  },
};

const actions = {
  needTemplateWorkOrderTaskLineItems(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItems(jsConn, itemDetails).then(jsConn => {
      context.commit(
        "LOAD_TEMPLATE_WORK_ORDER_TASK_LINE_ITEMS",
        jsConn.response,
      );
      return Promise.resolve(jsConn);
    });
  },
  needTemplateWorkOrderTaskLineItem(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api.getItem(jsConn, itemDetails).then(jsConn => {
      context.commit(
        "LOAD_TEMPLATE_WORK_ORDER_TASK_LINE_ITEM",
        jsConn.response,
      );
      return Promise.resolve(jsConn);
    });
  },
  createTemplateWorkOrderTaskLineItem(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .createItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit(
          "LOAD_TEMPLATE_WORK_ORDER_TASK_LINE_ITEM",
          jsConn.response,
        );
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
  updateTemplateWorkOrderTaskLineItem(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .updateItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit(
          "LOAD_TEMPLATE_WORK_ORDER_TASK_LINE_ITEM",
          jsConn.response,
        );
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
  deleteTemplateWorkOrderTaskLineItem(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);

    return api
      .deleteItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit(
          "LOAD_TEMPLATE_WORK_ORDER_TASK_LINE_ITEM",
          emptyTemplateWorkOrderTaskLineItem,
        );
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  templateWorkOrderTaskLineItems: (
    state: TemplateWorkOrderTaskLineItemState,
  ) => {
    return state.templateWorkOrderTaskLineItems;
  },
  templateWorkOrderTaskLineItem: (
    state: TemplateWorkOrderTaskLineItemState,
  ) => {
    return state.templateWorkOrderTaskLineItem;
  },
  templateWorkOrderTaskLineItemsForTable: (
    state: TemplateWorkOrderTaskLineItemState,
  ) => {
    return state.templateWorkOrderTaskLineItems;
  },
};

const templateWorkOrderTaskLineItemsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default templateWorkOrderTaskLineItemsModule;
